import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";

const proficiencyCompletionsReducer = createAsyncReducer({
    name: 'proficiencyCompletions',
    initialState: {
        records: {},
        loading: false,
        errorMessage: ''
    },
    reducers: (create) => ({
        loadByCertificationId: create.asyncThunk(
            async (certification_id) => {
                return await Fetch.get(Routes.ajax_proficiency_completions_path({ certification_id }));
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    const { message } = action.error;
                    state.errorMessage = message;
                    state.loading = false;
                }
            }
        ),
        loadByCertificationProficiencyId: create.asyncThunk(
            async (certification_proficiency_id) => {
                return await Fetch.get(Routes.ajax_proficiency_completion_path({ certification_proficiency_id }));
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    const { message } = action.error;
                    state.errorMessage = message;
                    state.loading = false;
                }
            }
        ),
        checkForCompletion: create.asyncThunk(
            async ({ certification_proficiency_id }) => {
                return await Fetch.get(Routes.ajax_proficiency_completions_check_path(certification_proficiency_id));
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    const { message } = action.error;
                    state.errorMessage = message;
                    state.loading = false;
                }
            }
        )
    })
});

export default proficiencyCompletionsReducer;